.empty-table{margin-bottom:3em}.status-submitted .status.ng-invalid,.reactions-submitted .status.ng-invalid{border:red 1px solid!important;border-radius:2px}
/*# sourceMappingURL=pregnancy-status-add-edit.component-FJRDCPHO.css.map */
